
<script>
import moment from 'moment'
export default {
  filters: {
    moment (str) {
      return str ? moment(str).format('LLL') : ''
    },
    dateFormat (str) {
      return str ? moment(str).format('YYYY/MM/DD') : ''
    },
    yearMonthFormat (str) {
      return str ? moment(str).format('YYYY/MM') : ''
    },
    weekFormat (str) {
      return moment(str).format('dddd')
    },
    periodFormat (period) {
      if (!period.Begin || !period.End) return '-'
      let LLL = 'YYYY/MM/DD HH:mm'
      if (!moment(period.Begin).isSame(period.End, 'year')) {
        return (
          moment(period.Begin).format(LLL) +
          '~' +
          moment(period.End).format(LLL)
        )
      }
      if (!moment(period.Begin).isSame(period.End, 'month')) {
        return (
          moment(period.Begin).format('YYYY MM/DD HH:mm') +
          '~' +
          moment(period.End).format('MM/DD HH:mm')
        )
      }

      if (!moment(period.Begin).isSame(period.End, 'date')) {
        return (
          moment(period.Begin).format('YYYY MM/DD HH:mm') +
          '~' +
          moment(period.End).format('MM/DD HH:mm')
        )
      } else {
        return (
          moment(period.Begin).format(LLL) +
          '~' +
          moment(period.End).format('HH:mm')
        )
      }

      // return (
      //   moment(period.Begin).format(LLL) + '~' + moment(period.End).format(LLL)
      // )
    },
    amountFormat (amount) {
      return (amount + '')
        .split('')
        .reverse()
        .join('')
        .replace(/(\d{3})(?=\d)/g, '$1,')
        .split('')
        .reverse()
        .join('')
    },
    yesorno (boolValue) {
      return boolValue ? '是' : '否'
    },
    getOrderID (order) {
      var suffix = '' + order.ID
      while (suffix.length < 7) suffix = '0' + suffix
      return order.CreatedAt.substring(2, 10).replace(/-/g, '') + suffix
    }
  }
}
</script>
